<template>
    <v-container max-width="100%" style="margin-top: 2%;">
      <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>
  
      <v-form ref="form" v-model="formValidado">
          <v-card style="margin-bottom: 15px;">
            <v-card-title style="color: #4a4a4a;">{{ $t('vehicleInspection.title') }}</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="3">
                        <v-select
                            v-model="idEmpresaSelected"
                            :items="empresas"
                            item-text="razao_social"
                            item-value="id_empresa"
                            outlined
                            :label="$t('vehicleInspection.fields.company') + ' *'"
                            :rules="[validaCampo]"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-autocomplete
                            v-model="idVeiculoSelected"
                            :items="veiculosEmpresa"
                            item-text="cod_veiculo"
                            item-value="id_veiculo"
                            outlined
                            :label="$t('vehicleInspection.fields.vehicle') + ' *'"
                            :rules="[validaCampo]"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-text-field
                            v-model="nomeResponsavel"
                            outlined
                            :label="$t('vehicleInspection.fields.responsible') + ' *'"
                            :rules="[validaCampo]"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            :close-on-content-click="false"
                            :return-value.sync="data"
                            :rules="[validaCampo]"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dataFormat"
                                    :label="$t('vehicleInspection.fields.date') + ' *'"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="data"
                                no-title
                                scrollable
                                locale="pt"
                                :max="today"
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                            >
                                {{ $t('button.cancel') }}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(data)"
                            >
                                {{ $t('button.validate') }}
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
          </v-card>

          <v-card style="margin-bottom: 15px;">
            <v-card-title style="color: #4a4a4a;">{{ $t('vehicleInspection.documentation') }}</v-card-title>
            <v-card-text>
                <merus-data-table
                    :headers="headersDocumentos"
                    :items="documentos"
                    :loading="loadingDocumentos"
                    sort-by="cod_documento"
                    locale="pt"
                    style="border-radius: 10px;"
                    hide-default-footer
                    :mobile-breakpoint="0"
                    :loading-text="$t('vehicleInspection.loadingDocuments')"
                >
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="$t('vehicleInspection.title')"
                            :token="token"
                            :items="documentos"
                            hide-search
                        />
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.cod_tipo_documento }}</td>
                            <td v-for="(st) in statusDocumentos" :key="`${item.id_documento}-${st.id_status_documento}`">
                                <v-checkbox 
                                    :value="item.id_status_documento === st.id_status_documento" 
                                    @change="alteraStatusDocumento(item, st.id_status_documento)"
                                ></v-checkbox>
                            </td>
                        </tr>
                    </template>
                </merus-data-table>

                <v-textarea
                    v-model="outrosDocumentos"
                    clearable
                    counter
                    no-resize
                    outlined
                    rows="1"
                    :label="$t('vehicleInspection.fields.otherDocuments') + ' *'"
                    style="margin-top: 10px;"
                    :rules="[(v) => (!v || v?.length <= 300) || $t('vehicleInspection.alerts.maxCharacters', { max: 300 })]"
                ></v-textarea>
            </v-card-text>
          </v-card>
          <v-card style="margin-bottom: 15px;" v-for="(bloco, b) in inspecao.blocos" :key="b">
            <v-card-title style="color: #4a4a4a;">{{ bloco.label }}</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="4" v-for="(campo, c) in bloco.campos.filter((c) => c.tipo === 'Select')" :key="`${campo.label}-${c}`">
                        <v-select
                            v-model="campo.valor"
                            :items="bloco.select"
                            outlined
                            :label="`${campo.label} *`"
                            :rules="[validaCampo]"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="12" v-for="(campo, c) in bloco.campos.filter((c) => c.tipo === 'Text')" :key="`${campo.label}-${c}`">
                        <v-textarea
                            v-model="campo.valor"
                            clearable
                            counter
                            no-resize
                            outlined
                            rows="1"
                            :label="campo.label"
                            style="margin-top: 10px;"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="12" v-for="(campo, c) in bloco.campos.filter((c) => c.tipo === 'Img')" :key="`${campo.label}-${c}`">
                        <v-file-input
                            v-model="campo.valor"
                            show-size
                            accept="png/jpg"
                            prepend-icon="mdi-camera"
                            :label="campo.label"
                        ></v-file-input>
                    </v-col>
                </v-row>
            </v-card-text>
          </v-card>
          <v-btn block dark color="primary" @click="save" height="50">{{ $t('button.send') }}</v-btn>
      </v-form>
    </v-container>
</template>
<script>
import LoadingComponent from './LoadingComponent.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";

export default {
    components: {
        LoadingComponent,
        CadastroToolbar,
        MerusDataTable
    },
    data: () => ({
        user: null, 
        token: null, 
        formValidado: false, 
        empresas: [],
        veiculos: [],
        idEmpresaSelected: null,
        idVeiculoSelected: null,
        nomeResponsavel: null, 
        data: null, 
        menu: false,
        loadingDocumentos: false,
        documentos: [],
        outrosDocumentos: null,
        statusDocumentos: [],
        cintoMotorista: null, 
        bancoPassageiro: null,
        cintoPassageiro: null,
        bancosDanificados: null,
        tacografo: null, 
        velocimetro: null, 
        limpParaBrisa: null, 
        leitorAbmMotorista: null, 
        leitorAbmPassageiro: null, 
        lacreSaidaEmergencia: null,
        etiquetaSaidaEmergencia: null, 
        buzina: null, 
        estepe: null, 
        macaco: null, 
        chaveRoda: null, 
        triangulo: null, 
        extintor: null, 
    }),
    computed: {
        loading() {
            return false;
        },
        defaultInspecao() {
            return {
            idEmpresa: null, 
            idVeiculo: null,
            responsavel: null, 
            data: null,
            documentos: [],
            outrosDocumentos: null, 
            blocos: [
                {
                    label: this.$t('vehicleInspection.sections.internalPart'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.loose'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.torn'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverSeatbelt'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerSeat'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerSeatbelt'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedSeatsNumbering'),
                            tipo: "Text",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenSeatPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.instruments'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.withoutSeal')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.tachograph'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.speedometer'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverAbmReader'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerAbmReader'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.windshieldWiper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.emergencyExit'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.seal'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.instructionLabel'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.equipment'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.horn'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.spareTire'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.jack'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.wheelWrench'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.triangle'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.fireExtinguisher'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.expired')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.windows'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverWindow'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenWindowPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.windshieldGlass'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.cracked'), 
                        this.$t('vehicleInspection.selectOptions.loose')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rear'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenGlassPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.lighting'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.burned'), 
                        this.$t('vehicleInspection.selectOptions.damaged'),
                        this.$t('vehicleInspection.selectOptions.withoutBulb')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightBeamRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightBeamLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lowBeamRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lowBeamLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightFrontRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightFrontLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightRearRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightRearLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.headlightRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.headlightLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTurnSignalRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTurnSignalLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTurnSignalRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTurnSignalLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverReadingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.ceilingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.readingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.stepLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.reverseLight'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.externalPart'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.scratched'), 
                        this.$t('vehicleInspection.selectOptions.dented'), 
                        this.$t('vehicleInspection.selectOptions.punctured'),
                        this.$t('vehicleInspection.selectOptions.wornOut')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontBumper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearBumper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.moldings'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.painting'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.plates'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damageLocationPhotos'),
                            tipo: "Img",
                            mult: true,
                            maxItens: 5,
                            valor: [],
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.tires'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.goodCondition'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.worn'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTireRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTireLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireInsideRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireOutsideRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireInsideLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireOutsideLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedTirePhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.wifi'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.working'), 
                        this.$t('vehicleInspection.selectOptions.doesNotHave'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.ac'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.working'),
                        this.$t('vehicleInspection.selectOptions.inoperative'), 
                        this.$t('vehicleInspection.selectOptions.doesNotHave'), 
                        this.$t('vehicleInspection.selectOptions.expired')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lastHygienizationDate'),
                            tipo: "Date",
                            valor: null,
                        }]
                    }
                ]
            };
        },
        inspecao() {
            return {
            idEmpresa: null, 
            idVeiculo: null,
            responsavel: null, 
            data: null,
            documentos: [],
            outrosDocumentos: null, 
            blocos: [
                {
                    label: this.$t('vehicleInspection.sections.internalPart'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.loose'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.torn'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverSeatbelt'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerSeat'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerSeatbelt'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedSeatsNumbering'),
                            tipo: "Text",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenSeatPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.instruments'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.withoutSeal')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.tachograph'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.speedometer'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverAbmReader'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.passengerAbmReader'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.windshieldWiper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.emergencyExit'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.seal'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.instructionLabel'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.equipment'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.horn'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.spareTire'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.jack'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.wheelWrench'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.triangle'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.fireExtinguisher'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.missing'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative'),
                        this.$t('vehicleInspection.selectOptions.expired')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.windows'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverWindow'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenWindowPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.windshieldGlass'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.cracked'), 
                        this.$t('vehicleInspection.selectOptions.loose')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rear'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.brokenGlassPhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.lighting'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.broken'), 
                        this.$t('vehicleInspection.selectOptions.burned'), 
                        this.$t('vehicleInspection.selectOptions.damaged'),
                        this.$t('vehicleInspection.selectOptions.withoutBulb')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.highBeamRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.highBeamLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lowBeamRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lowBeamLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightFrontRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightFrontLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightRearRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.watchmanLightRearLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.headlightRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.headlightLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTurnSignalRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTurnSignalLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTurnSignalRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTurnSignalLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.driverReadingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.ceilingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.readingLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.stepLight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.reverseLight'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.externalPart'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.scratched'), 
                        this.$t('vehicleInspection.selectOptions.dented'), 
                        this.$t('vehicleInspection.selectOptions.punctured'),
                        this.$t('vehicleInspection.selectOptions.wornOut')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rightSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.leftSide'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontBumper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearBumper'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.moldings'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.painting'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.plates'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damageLocationPhotos'),
                            tipo: "Img",
                            mult: true,
                            maxItens: 5,
                            valor: [],
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.tires'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.goodCondition'),
                        this.$t('vehicleInspection.selectOptions.damaged'), 
                        this.$t('vehicleInspection.selectOptions.worn'), 
                        this.$t('vehicleInspection.selectOptions.outOfStandard')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTireRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.frontTireLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireInsideRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireOutsideRight'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireInsideLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.rearTireOutsideLeft'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.damagedTirePhoto'),
                            tipo: "Img",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.wifi'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.inOrder'),
                        this.$t('vehicleInspection.selectOptions.yes'), 
                        this.$t('vehicleInspection.selectOptions.no'), 
                        this.$t('vehicleInspection.selectOptions.inoperative')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        }]
                },
                {
                    label: this.$t('vehicleInspection.sections.ac'),
                    select: [
                        this.$t('vehicleInspection.selectOptions.working'),
                        this.$t('vehicleInspection.selectOptions.inoperative'), 
                        this.$t('vehicleInspection.selectOptions.doesNotHave'), 
                        this.$t('vehicleInspection.selectOptions.expired')
                    ],
                    campos: [
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.state'),
                            tipo: "Select",
                            valor: null,
                        },
                        { 
                            label: this.$t('vehicleInspection.inspectionFields.lastHygienizationDate'),                            
                            tipo: "Date",
                            valor: null,
                        }]
                    }
                ]
            };
        },
        loadingMessage() {
            return this.$t('system.messages.loading');
        },
        today() {
            return new Date().toISOString();
        },
        veiculosEmpresa() {
            if (this.idEmpresaSelected) {
                return this.veiculos.filter((v) => v.id_empresa === this.idEmpresaSelected);
            }

            return [];
        },
        dataFormat() {
            if (!this.data) return null;
            const [ano, mes, dia] = this.data.split('-');
            return `${dia}/${mes}/${ano}`;
        },
        headersDocumentos() {
            let headers = [{ text: this.$t('vehicleInspection.fields.code') }];

            this.statusDocumentos.forEach((s) => {
                headers.push({ 
                    text: `${s.descricao_status_documento}`,
                    value: `status_${s.id_status_documento}`,
                    sortable: false,
                    align: 'center'
                });
            })

            return headers;
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user")).id_usuario;
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        validaCampo(v) {
            return !!v || this.$t('validation.required');
        },
        initialize() {
            this.populaEmpresas();
            this.populaVeiculos();
            this.populaStatusDocumentos();
            this.populaDocumentos();
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                onSuccess: (response) => {
                    this.veiculos = response.data;
                },
            });
        },
        populaStatusDocumentos() {
            apiController.request(apiController.endpoints.getallStatusdocumentos, {
                onSuccess: (response) => {
                    this.statusDocumentos = response.data;
                    this.statusDocumentos.forEach(status => {
                        status.descricao_status_documento = translateDbField(
                            status.translation_key,
                            status.descricao_status_documento
                        );
                        return status;
                    });
                },
            });
        },
        populaDocumentos() {
            apiController.request(apiController.endpoints.getTiposdocumentosveiculos, {
                onSuccess: (response) => {
                    this.documentos = response.data.map((d) => ({
                        ...d,
                        cod_tipo_documento: translateDbField(
                            d.translation_key,
                            d.cod_tipo_documento
                        )
                    }));
                },
            });
        },
        alteraStatusDocumento(doc, idStatus) {
            doc.id_status_documento = idStatus;
        },
        save() {
            this.$refs.form.validate();
            if (this.formValidado) {
                this.inspecao.data = this.data;
                this.inspecao.documentos = this.documentos;
                this.inspecao.outrosDocumentos = this.outrosDocumentos;
                this.inspecao.idEmpresa = this.idEmpresaSelected;
                this.inspecao.idVeiculo = this.idVeiculoSelected;
                this.inspecao.responsavel = this.nomeResponsavel;

                let payload = {
                    id_usuario_inclusao: this.user,
                    json: JSON.stringify(this.inspecao)
                };

                apiController.request(apiController.endpoints.insertChecklist, {
                    data: payload,
                    silent: true,
                    onSuccess: (response) => {
                        console.log(response.data);
                        if (response.data.erro) {
                            EventBus.$emit('show-alert', {
                                mensagem: 'Erro ao salvar a checklist',
                                tipo: 'error'
                            });
                        } else {
                            EventBus.$emit('show-alert', {
                                mensagem: 'Checklist salva com sucesso',
                                tipo: 'success'
                            });
                        }
                        this.saveInspecaoVeiculo(response.data.insertId);
                        this.$nextTick(() => {
                            this.populaDocumentos();
                            this.$refs.form.resetValidation();
                            window.scrollTo(0, 0);
                        })
                    },
                    onError: (e) => {
                        console.log(e);
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        saveInspecaoVeiculo(idchecklist) {
            let payload = {
                data: this.data,
                id_veiculo: this.idVeiculoSelected,
                id_checklist: idchecklist,
                documentos: this.documentos.map((d) => [this.idVeiculoSelected, d.id_tipo_documento, d.id_status_documento]),
            };

            apiController.request(apiController.endpoints.insertInspecaoveiculo, {
                data: payload,
                silent: true,
                onSuccess: (response) => {
                    console.log(response.data);
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        }
    }
}
</script>
<style>
    
</style>